import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

const products = [
  {
    to: '/products/oneschool-companion',
    tag: 'AC',
    color: 'linear-gradient(135deg,#2f6fed,#16294a)',
    status: 'live',
    name: 'OneSchool Companion',
    audience: 'For teachers · Desktop app',
    blurb:
      'Install on your work or home computer. OneSchool Companion helps teachers stay on top of daily admin so there’s more time for actual teaching.',
  },
  {
    to: '/products/voceda',
    tag: 'VO',
    color: 'linear-gradient(135deg,#f5a524,#b8720b)',
    status: 'live',
    name: 'Voceda',
    audience: 'For teachers · Web app · voceda.com',
    blurb:
      'Generate classroom-ready learning resources online. Soon, Voceda will also turn videos and transcripts straight into worksheets.',
  },
  {
    to: '/products/smstutor',
    tag: 'ST',
    color: 'linear-gradient(135deg,#1c8a56,#0f1c30)',
    status: 'soon',
    name: 'SMS Tutor',
    audience: 'For parents & guardians · Web app · smstutor.com',
    blurb:
      'A web platform where parents and guardians will be able to arrange tutoring support to help teach their students. Currently in development.',
  },
];

function Products() {
  usePageMeta(
    'Products',
    'OneSchool Companion, Voceda and SMS Tutor — software for teachers, students, and families from Australia College.'
  );

  return (
    <>
      <section className="product-hero">
        <div className="container">
          <span className="eyebrow">Products</span>
          <h1>One company, three focused tools</h1>
          <p className="product-hero-lead">
            Each Australia College product is built around a specific
            audience and a specific problem — from teacher productivity to
            resource creation to tutoring support for families.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-3">
            {products.map((p) => (
              <Link to={p.to} className="card" key={p.to}>
                <div className="card-top-row">
                  <div className="card-icon" style={{ background: p.color }}>
                    {p.tag}
                  </div>
                  <span className={`badge badge--${p.status === 'live' ? 'live' : 'soon'}`}>
                    {p.status === 'live' ? 'Available' : 'Coming soon'}
                  </span>
                </div>
                <h3>{p.name}</h3>
                <p style={{ fontWeight: 600, color: 'var(--text)', marginBottom: 4, fontSize: '0.85rem' }}>
                  {p.audience}
                </p>
                <p>{p.blurb}</p>
                <span className="card-link">Learn more →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2 style={{ marginBottom: 8 }}>Not sure which product is right for you?</h2>
              <p>Tell us a bit about what you're after and we'll point you in the right direction.</p>
            </div>
            <div className="cta-banner-actions">
              <Link to="/contact" className="btn btn-primary">
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Products;
